import { device } from 'components/styles/MediaQuery';
import styled, { css } from 'styled-components';

interface LogoProps {
  height?: number;
  mobHeight?: number;
}

export const ScLogo = styled.div<LogoProps>`
  .logo {
    height: ${({ height }) => (height ? `${height}px` : '24px')};
    display: flex;
    justify-content: center;
    ${({ mobHeight }) =>
      mobHeight &&
      css`
        @media (${device.mobileS}) {
          height: ${mobHeight}px;
        }
      `}

    svg {
      height: 100%;
      object-fit: contain;

      path[class*='withGreenGradient'] {
        fill: url(#green-gradient);
      }
    }

    .cms-logo {
      object-fit: contain;
    }
  }
`;
